// Las miniaturas de lo generado, para que cada foto aparezca en SU tarjeta apenas llega
// (ADR-2026-10-14-el-catalogo-se-arma-con-la-guia: sin columna de creaciones al costado).
// Firma una sola vez cada id; un id que falló se vuelve a pedir en el próximo cambio.
import { useEffect, useRef, useState } from 'react';
import { preloadGeneratedImages } from '../../../../utils/preloadGeneratedImages';

export function useMiniaturas(ids: readonly string[], companyId: string | null): Map<string, string> {
  const [mapa, setMapa] = useState(() => new Map<string, string>());
  const pedidos = useRef(new Set<string>());
  const clave = ids.join(',');
  useEffect(() => {
    if (!companyId) return;
    const faltan = ids.filter((id) => !pedidos.current.has(id));
    if (faltan.length === 0) return;
    for (const id of faltan) pedidos.current.add(id);
    void preloadGeneratedImages(faltan, companyId)
      .then((filas) => {
        setMapa((prev) => {
          const m = new Map(prev);
          for (const f of filas) m.set(String(f.id), f.optSignedUrl || f.signedUrl);
          return m;
        });
      })
      .catch(() => {
        for (const id of faltan) pedidos.current.delete(id);
      });
    // `clave` resume `ids`: con el array como dependencia el efecto correría en cada render.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clave, companyId]);
  return mapa;
}
